
<template>
  <div class="company-content">
    <div class="company-header">
      <h1>{{$_('company_list')}}</h1>
    </div>

    <div class="company-list">
      <h2>{{$_('company_choice')}}</h2>
      <CompanyList />
    </div>
  </div>
</template>

<script>
import CompanyList from "@/modules/societe/components/CompanyList";

export default {
  name: "Company",
  data() {
    return {
      selected: ""
    };
  },
  components: {
    CompanyList
  }
};
</script>

<style scoped>
.company-content {
  padding: 50px 30px;
}

.company-header {
  margin-bottom: 40px;
  padding: 0px 15px;
}

.company-list h2 {
  padding: 0px 15px;
  margin-bottom: 15px;
}
</style>